if (!customElements.get('ft-price-stage')) {
  customElements.define('ft-price-stage', class extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.deadline);
      this.refresh();
      this.onVisibility = () => this.refresh();
      document.addEventListener('visibilitychange', this.onVisibility);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
    refresh() {
      clearTimeout(this.timer);
      const expired = !Number.isFinite(this.deadline) || Date.now() >= this.deadline;
      const offer = this.querySelector('[data-stage-offer]');
      if (offer) offer.hidden = expired || this.dataset.launchEligible !== 'true';
      const price = this.closest('[id^="price-"]');
      if (expired && price) price.setAttribute('data-ft-launch-ended', '');
      if (expired) {
        if (offer) offer.remove();
        return;
      }
      this.timer = setTimeout(() => this.refresh(), Math.min(60000, this.deadline - Date.now() + 25));
    }
  });
}